import { format } from 'date-fns';

import { useDateLocale } from 'src/hooks/use-date-locale';

import { HousekeepingInspection } from '../api';

export const useFormatInspectionDates = (inspection: HousekeepingInspection) => {
    const locale = useDateLocale();
    const inspectionDate = new Date(inspection.inspection_date);
    const optInDeadline = new Date(inspection.opt_in_deadline);

    const date = format(inspectionDate, 'd', { locale });
    const day = format(inspectionDate, 'EEEE', { locale });
    const month = format(inspectionDate, 'LLL', { locale });
    const formattedOptInDeadline = format(optInDeadline, 'd LLL hh:mm bb', { locale });

    return { date, day, month, formattedOptInDeadline };
};
